import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/spiritual/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const StorytellingLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionTips = () => {
    return (
      <>  
      <Grid stackable className={styles.learnMoreFullDiv} >
        <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
          <Grid.Column stretched className={styles.hghlgtItemColFull} >
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}WriteIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                <p className={styles.highlightsItemHeaderTitle} >PREPARING YOUR QUESTIONS</p>
                <Header.Subheader>
                  <p className={styles.learnMoreAccordionText} > 
                    What are some things you wish you had been able to ask older family members before they passed? 
                    What are things you would want others to know about you when you are gone? 
                    Asking yourself these questions can help to develop a list of talking points to discuss with the older adult. </p>
                  <p className={styles.learnMoreAccordionTextEmphasis} > Having talking points and questions prepared  can also be helpful if the older adult is unsure what to talk about, 
                    can't seem to find a good place to start, or is hesitant/shy to discuss their life experiences.</p>
                  <p className={styles.learnMoreAccordionText} > 
                    Some may be more receptive to more specific questions while others may respond to more open-ended or conversational
                    topics. Attempting to do this all at once can be emotionally exhausting and important moments could be missed if there 
                    isn't time to reflect. One positive approach could be to setup a weekly visit or call where you discuss just one or
                    two questions or topics at a time. This way there is time to dig deeper into the questions and topics, there is a conversation
                    to look forward to each week, and they have the week to reflect on past conversations and can bring up anything else they 
                    remembered in the upcoming conversations.
                  </p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
        </Grid.Row>
        <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
          <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}ValuesIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                <p className={styles.highlightsItemHeaderTitle} >FAMILY VALUES</p>
                <Header.Subheader> 
                  <p className={styles.learnMoreAccordionText} >
                    The transmission of family values can be accomplished by encouraging older adults to document what is really important 
                    in their lives (i.e. intergenerational transfers of wisdom) and how this idea of what is most important shifted throughout
                    their lives.</p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
          <Grid.Column width={7} stretched doubling className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}GenerationIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                <p className={styles.highlightsItemHeaderTitle} >FUTURE MESSAGES & ADVICE</p>
                <Header.Subheader> 
                  <p className={styles.learnMoreAccordionText} >
                    Consider recording futuristic messages and advice from the older adult to younger members (or yet-to-be-born members) of the 
                    family around significant events that have not happened yet. They can also record messages to share with grandchildren on future 
                    special occasions. </p>
                  <p className={styles.learnMoreAccordionText} > 
                    Topics can include religious events, high school and college graduations, engagement and marriage, birth of great grandchildren, 
                    selecting a career, gaining a driving license, and more. They can also include tougher, difficult subjects like: drinking, drugs, 
                    and depression.</p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
          <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}StoryIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                <p className={styles.highlightsItemHeaderTitle} >LIFE STORIES</p>
                <Header.Subheader>  
                  <p className={styles.learnMoreAccordionText} >
                    Everyone has a story to tell. Getting to know an older adult through reminiscing can help family members discover many 
                    positive qualities they never realized or appreciated. Sharing everyday experiences, little moments that makes them smile, and 
                    special events throughout their lives. </p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
        </Grid.Row>
      </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Suggestions And Ideas For Documenting </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    }
  ];
  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}MotherDaughterTea2.jpeg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );   
};

export default observer(StorytellingLearnMore);
